import { useEffect, useReducer, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { dataTel1NewEvt, optionSelector } from "../../config/apiSPA.js";
const initialstate = {
  title: "",
  lokasi_trainings_id: null,
  startDate: "",
  endDate: "",
  lembaga_trainings_id: null,
  instructors: [],
  duration: 0,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "title":
      return { ...state, title: action.value };
    case "lokasi_trainings_id":
      return { ...state, lokasi_trainings_id: action.value };
    case "startDate":
      return { ...state, startDate: action.value };
    case "endDate":
      return { ...state, endDate: action.value };
    case "lembaga_trainings_id":
      return { ...state, lembaga_trainings_id: action.value };
    case "instructors":
      return { ...state, instructors: action.value };
    case "duration":
      return { ...state, duration: action.value };
  }
};
function ModalNew({ show, onHideModal, statusModal }) {
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [instructorList, setInstructorList] = useState([]);
  const [institutionList, setInstitutionList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [validationInst, setValidationInst] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialstate);

  function handleChangeSelectedInst(val) {
    dispatch({ type: "instructors", value: val });
  }

  function handleClickSubmit(val) {
    setSubmitDisabled(true);
    dataTel1NewEvt(val).then((res) => {
      if (res.status === "true") {
        statusModal(true);
        setShowModal(false);
      }
    });
  }

  function onShow() {
    setLoadingStatus(true);
    optionSelector(`/instructor`).then((res) => {
      setLoadingStatus((v) => v + 1);
      setInstructorList(res);
    });
    optionSelector(`/institution`).then((res) => {
      setLoadingStatus((v) => v + 1);
      setInstitutionList(res);
    });
    optionSelector(`/location`).then((res) => {
      setLoadingStatus((v) => v + 1);
      setLocationList(res);
    });
  }
  function onHide() {
    setShowModal(false);
    onHideModal();
  }

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  useEffect(() => {
    if (state.title && state.lokasi_trainings_id && state.lembaga_trainings_id && state.startDate && state.duration && state.endDate && validationInst) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [state, validationInst]);
  return (
    <>
      {/* {console.log(submitDisabled)} */}
      <Modal show={showModal} onHide={onHide} onShow={onShow}>
        <ModalHeader closeButton>
          <h5 className="modal-title">New Training Evaluation Form</h5>
        </ModalHeader>

        <ModalBody>
          {loadingStatus < 3 ? (
            <p>Loading.....</p>
          ) : (
            <>
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="to">
                  Training Title
                </label>
                <input onChange={(e) => dispatch({ type: "title", value: e.target.value })} type="text" className="form-control" id="to" />
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Location</label>
                <Select onChange={(e) => dispatch({ type: "lokasi_trainings_id", value: e.value })} options={locationList} isSearchable classNamePrefix="react-select" />
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Instructor</label>
                <InstructorSelector instructorList={instructorList} selectedInst={(val) => handleChangeSelectedInst(val)} validation={(val) => setValidationInst(val)} />
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Institution</label>
                <Select onChange={(e) => dispatch({ type: "lembaga_trainings_id", value: e.value })} options={institutionList} isSearchable classNamePrefix="react-select" />
              </div>
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="start">
                  Start Date
                </label>
                <input onChange={(e) => dispatch({ type: "startDate", value: e.target.value })} type="date" className="form-control" id="start" />
              </div>
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="end">
                  End Date
                </label>
                <input onChange={(e) => dispatch({ type: "endDate", value: e.target.value })} type="date" className="form-control" id="end" />
              </div>
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="duration">
                  Duration ( {state.duration} minutes)
                </label>
                <input type="range" onChange={(e) => dispatch({ type: "duration", value: parseInt(e.target.value) })} defaultValue={0} min={0} max={60} className="form-range" id="duration" />
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button onClick={() => handleClickSubmit(state)} type="button" className={submitDisabled ? "btn btn-outline-theme disabled" : "btn btn-outline-theme"}>
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default ModalNew;

const initialInstructors = [{ id: 1, instId: null }];

function InstructorSelector({ instructorList, selectedInst, validation }) {
  const [instructors, setInstructors] = useState(initialInstructors);
  const [removebtnDisabled, setRemoveBtnDisabled] = useState("btn btn-outline-secondary d-block disabled");
  function handleChangeValue(select, id) {
    setInstructors(instructors.map((ins) => (ins.id === id ? { ...ins, instId: select.value } : ins)));
  }
  function handleClickAdd() {
    const newInst = { id: instructors.length + 1, instId: null };
    setInstructors([...instructors, newInst]); // Insert new object
  }

  function handleDeleteInstructor(id) {
    setInstructors(instructors.filter((a) => a.id !== id));
  }
  function checkDuplicate(insts, key) {
    const seen = new Map();
    const duplicates = [];

    insts.forEach((item) => {
      if (seen.has(item[key])) {
        duplicates.push(item);
      } else {
        seen.set(item[key], true);
      }
    });

    return duplicates;
  }

  function checkBlank(insts) {
    let blank = false;
    insts.forEach((inst) => {
      if (!inst.instId) {
        blank = true;
      }
    });
    return blank;
  }
  useEffect(() => {
    setRemoveBtnDisabled(instructors.length > 1 ? "btn btn-outline-secondary d-block" : "btn btn-outline-secondary d-block disabled");
    validation(checkBlank(instructors) || checkDuplicate(instructors, "instId").length > 0 ? false : true);
    selectedInst(instructors);
  }, [instructors]);
  return (
    <>
      {instructors.map((val, index) => (
        <div key={index} className="mb-3">
          <div className="row mb-3 gx-3">
            <div className="col-10">
              <Select onChange={(e) => handleChangeValue(e, val.id)} options={instructorList} isSearchable classNamePrefix="react-select" />
            </div>
            <div className="col-2">
              <a href="#/" onClick={() => handleDeleteInstructor(val.id)} className={removebtnDisabled}>
                <i className="bi bi-x-lg"></i>
              </a>
            </div>
          </div>
        </div>
      ))}
      <a href="#/" className="mt-5 mx-3" onClick={() => handleClickAdd()}>
        Add
      </a>
    </>
  );
}
